import { render, staticRenderFns } from "./IconPointCircle.vue?vue&type=template&id=03720466"
import script from "./IconPointCircle.vue?vue&type=script&lang=js"
export * from "./IconPointCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports